import React from "react";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import SettingsEthernetIcon from "@mui/icons-material/SettingsEthernet";
import { useDispatch, useSelector } from "react-redux";
import CancelIcon from "@mui/icons-material/Cancel";
import SaveAltIcon from "@mui/icons-material/SaveAlt";
import { formatDistance } from "../../NewRoute/handleActionsMaps";
import { handleError } from "../../../../utils/handleError";
import toast from "react-hot-toast";
import {
  addNewRoute,
  getRoutesAPI,
  getRoutesAssignedAPI,
} from "../../../../services/rest/routes/routesServices";
import { useNavigate } from "react-router-dom";
import {
  clearRoute,
  setlistRoutes,
  setListRoutesAssigned,
} from "../../../../redux/slice/routeSlice";
import { filterRoutesOfMembership } from "../../../../utils/FilterRoutesOfMembership";

const ModalSaveRoute = ({
  open,
  setOpen,
  setLoading,
  setShowModalLimitRoutes,
}) => {
  const { route, totalOfRoutes } = useSelector((state) => state.routeReducer);
  const { routeLimit, lastPayment, nextPayment } = useSelector(
    (state) => state.membershipReducer
  );
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const handleClose = () => setOpen(false);
  const handleSubmit = async (event) => {
    try {
      setLoading(true);
      event.preventDefault();
      const formData = new FormData(event.currentTarget);
      const formJson = Object.fromEntries(formData.entries());
      formJson.coordinates = route?.landMarks ?? [];
      formJson.distance = route?.distance ?? 0;
      formJson.estimatedTime = route?.estimatedTime ?? "0 min";
      // if (totalOfRoutes >= routeLimit) {
      //   setShowModalLimitRoutes(true);

      //   toast.error(
      //     `Has alcanzado el limite de rutas. \n Tu plan actual solo permite ${routeLimit} rutas.`
      //   );
      //   setOpen(false);
      //   setLoading(false);
      //   return;
      // }
      await addNewRoute(formJson);
      const listRoutes = await getRoutesAPI();
      const routesAssigned = await getRoutesAssignedAPI(); // peticion a rutas asignadas

      dispatch(
        setListRoutesAssigned({ listRoutesAssigned: routesAssigned ?? [] })
      );
      const totalRoutes = [...listRoutes, ...routesAssigned];
      const routesOfMembership = filterRoutesOfMembership(
        { paymentDate: lastPayment, expiresDateMembership: nextPayment },
        totalRoutes ?? []
      );

      dispatch(
        setlistRoutes({
          listRoutes: listRoutes ?? [],
          totalOfRoutesMembership: routesOfMembership ?? 0,
        })
      );
      handleClose();
      setLoading(false);
      dispatch(clearRoute());
      toast.success("Ruta guardada con exito.");
      navigate("/dashboard/rutasComplete");
    } catch (error) {
      setLoading(false);
      const { message } = handleError(error);
      toast.error(`En este momento no se pudo guardar la ruta. \n ${message}`);
    }
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      slotProps={{
        paper: {
          component: "form",
          onSubmit: (event) => {
            handleSubmit(event);
          },
        },
      }}
    >
      <DialogContent sx={{ padding: 5 }}>
        <DialogTitle>
          <Typography sx={{ textAlign: "center" }} variant="h5">
            Guarda tu Ruta.
          </Typography>
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              gap: 4,
              marginTop: 2,
            }}
          >
            <Box sx={{ display: "flex", justifyContent: "center", gap: 1 }}>
              <SettingsEthernetIcon style={{ color: "#e7ef7d" }} />
              <Typography sx={{ textAlign: "center" }}>
                Distancia : {formatDistance(route?.distance ?? 0)}
              </Typography>
            </Box>
          </Box>
        </DialogTitle>
        <Box sx={{ display: "flex", flexDirection: "column", gap: 4 }}>
          <Box sx={{ display: "flex", gap: 2, width: "100%" }}>
            <Box>
              <TextField
                autoFocus
                required
                margin="dense"
                id="nameRoute"
                name="nameRoute"
                label="Nombre de la Ruta"
                type="text"
                fullWidth
                variant="standard"
              />
            </Box>
            <Box>
              <TextField
                autoFocus
                required
                margin="dense"
                id="description"
                name="description"
                label="Descripción de la Ruta"
                type="text"
                fullWidth
                variant="standard"
              />
            </Box>
          </Box>
          <Box sx={{ display: "flex", gap: 2, width: "100%" }}>
            <Box sx={{ width: "50%" }}>
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">Terreno</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  label="Terreno"
                  name="terrainType"
                  required
                >
                  <MenuItem value={"Pista"}>Pista</MenuItem>
                  <MenuItem value={"Asfalto"}>Asfalto</MenuItem>
                  <MenuItem value={"Natural"}>Natural</MenuItem>
                </Select>
              </FormControl>
            </Box>
            <Box sx={{ width: "50%" }}>
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">
                  Dificultad
                </InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  label="Dificultad"
                  name="difficulty"
                  required
                >
                  <MenuItem value={"Facil"}>Facil</MenuItem>
                  <MenuItem value={"Medio"}>Medio</MenuItem>
                  <MenuItem value={"Dificil"}>Dificil</MenuItem>
                </Select>
              </FormControl>
            </Box>
          </Box>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button
          variant="outlined"
          onClick={handleClose}
          sx={{ borderColor: "white", color: "white" }}
          startIcon={<CancelIcon />}
        >
          Cancelar
        </Button>
        <Button
          variant="contained"
          type="submit"
          sx={{ backgroundColor: "#e7ef7d" }}
          startIcon={<SaveAltIcon />}
        >
          Guardar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ModalSaveRoute;
